import styled from 'styled-components';
const CodeDetailStyled = styled.div`
  background-color: #fff;
  width: 1300px;
  .Mui-disabled {
    .text-detail-label {
      color: #212121;
    }
    .text-detail-info {
      color: #212121;
    }
    .css-8sgtit-MuiInputBase-input-MuiInput-input.Mui-disabled {
      -webkit-text-fill-color: #212121;
    }
  }
  /* height: 700px; */
  .first-section {
    padding: 0 24px;
  }
  margin-bottom: 24px;
  .second-section {
    overflow-y: auto;
  }
`;
export default CodeDetailStyled;
